// extracted by mini-css-extract-plugin
export default {"footer":"index_footer_cHSWY","links":"index_links_pEYqa","divider":"index_divider_vAJ0P","span":"index_span_SBCna"};